import { MAKEUP_CLASS } from '.';

export const hasNewMakeupClass = value => dispatch => {
  dispatch({
    type: MAKEUP_CLASS.TOGGLE_HAS_NEW_MAKEUP_CLASS,
    load: value,
  });
};
